module.exports = __webpack_public_path__ + "static/media/success.e10fb2d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/success.mp3
// module id = Uz62
// module chunks = 300